const cablePropertyMap = {
  'Farbe': 'cableColor',
  'artikel_id': 'id',
  'Adertyp': 'coreType',
  'Besonderheit': 'specialFeatures',
  'Einzelelemente Ø': 'diameter',
  'Fabrikat': 'manufacturer',
  'Faseranzahl': 'fiberCount',
  'Faserklasse': 'fiberClass',
  'Fasertyp': 'fiberType',
  'Kabelbezeichnung': 'cableType',
  'Außendurchmesser': 'trunkDiameter',
  'CPR': 'cpr'
}

const plugPropertyMap = {
  'Farbe': 'plugColor',
  'artikel_id': 'id',
  'Ausführung': 'plex',
  'Clip': 'clip',
  'Fabrikat': 'manufacturer',
  'Faser': 'fiberMode',
  'Ferrule': 'ferruleMaterial',
  'Politur': 'polish',
  'Steckertyp': 'plugType',
  'Variante': 'variant',
  'Besonderheit Bez. 1': 'speciality1',
  'Grade B+': 'classBPlus'
}

const bendProtectionPropertyMap = {
  'artikel_id': 'id',
  'Fabrikat': 'manufacturer',
  'Farbe': 'bendProtectionColor',
  'Flexibilitaet': 'flexibility'
}

const productParametersPropertyMap = {
  'Einsatzgebiet': 'application',
  'Max. Zugkraft': 'traction',
  'Mantelmaterial': 'cloakMaterial',
  'Einsatztemperatur': 	'operationTemperature',
  'Außendurchmesser': 'cloakDiameter',
  'Min. Biegeradius':	'minimalBendRadius',
  'Kabelgewicht':	'weight',
  'Brandverhalten':	'fireBehavior',
  'Querdruckfestigkeit':	'crushStrength',
  'Bauartspezifikation': 'designSpecification',
  'Ferrule': 'ferruleProperties',
  'Steckzyklen': 'plugCycles',
  'Betriebstemperatur': 'operationTemperature',
  'Einfügedämpfung': 'insertionLoss',
  'Einfügedämpfung (IL)': 'insertionLoss',
  'Rückflussdämpfung': 'returnLoss',
  'Rückflussdämpfung (RL)': 'returnLoss',
  'RoHS': 'RoHS',
  'REACH-Verordnung': 'REACH',
  'CPR Klasse': 'cprClass'
}

const whipsPropertyMap = {
  'artikel_id': 'id',
  'Bezeichnung1': 'type',
  'Bezeichnung2': 'description',
  'Länge': 'length',
  'Farbe': 'color'
}

const spreadersPropertyMap = {
  'artikel_id': 'id',
  'Bezeichnung1': 'description',
  'Bezeichnung2': 'material',
  'Fach': 'timesLiteral',
  'FachNummer': 'times'
}

const protectionsPropertyMap = {
  'artikel_id': 'id',
  'Bezeichnung1': 'description',
  'Bezeichnung2': 'application',
}

const fixationsPropertyMap = {
  'artikel_id': 'id',
  'Bezeichnung1': 'forCableType',
  'Bezeichnung2': 'description',
  'Groesse': 'size',
}

const labelsPropertyMap = {
  'artikel_id': 'id',
  'Beschreibung': 'longDescription',
  'Bezeichnung1': 'description1',
  'Bezeichnung2': 'description2',
  'Tülle': 'onPipe'
}

export function mapProperties ( type, items ) {
  // eslint-disable-next-line
  // console.log(type, items)
  switch ( type ) {
    case 'cables': 
      return mapListOfItems(items, cablePropertyMap)
    case 'plugs':
      return mapListOfItems(items, plugPropertyMap)
    case 'bendProtections':
      return mapListOfItems(items, bendProtectionPropertyMap)
    case 'cablesPlugsCombinations':
    case 'plugsBendProtectionsCombinations':
    case 'cablesWhipsCombinations':
    case 'plugsWhipsCombinations':
    case 'cablesFixationsCombinations':
    case 'cablesProtectionsCombinations':
    case 'cablesSpreadersCombinations':
      return items
    case 'productParameters':
      return mapListOfItems(items, productParametersPropertyMap)
    case 'whips':
      return mapListOfItems(items, whipsPropertyMap)
    case 'spreaders':
      return mapListOfItems(items, spreadersPropertyMap)
    case 'protections':
      return mapListOfItems(items, protectionsPropertyMap)
    case 'fixations':
      return mapListOfItems(items, fixationsPropertyMap)
      case 'labels':
        return mapListOfItems(items, labelsPropertyMap)
    default:
      throw 'property map type unknown'
  }
}

function mapListOfItems (items, propertyMap) {
  return items.map(inputItem => {
    let mappedObject = {}
    Object.entries(inputItem).forEach(([key, value]) => {
      if ( key.indexOf('(') >= 0 || key.indexOf(')') >= 0 ) throw 'illegal parameter name for mapping: ' + key
      if (propertyMap[key])
        return mappedObject[propertyMap[key]] = String(value)
    })

    if (inputItem['artikel_id'] === 'XA03-0026' && (!mappedObject['plex'] || mappedObject['plex'] === '') && mappedObject['plugType'] === 'SN EZ-Flip') {
      mappedObject['plex'] = 'SN EZ-Flip'
    }

    return mappedObject
  })
}

export function getDoubleColorObject (colorString) {
  return colorString.split('/').reduce((accumulator, value, index, array) => {
    if (array.length > 2) throw 'bendProtection color is not parsable'
    
    const indexMap = ['colorTop', 'colorBottom']

    if (array.length === 1) {
      // rot/schwarz -> rot oben, schwarz unten
      accumulator[indexMap[0]] = value
      accumulator[indexMap[1]] = value
    }

    accumulator[indexMap[index]] = value
    return accumulator
  }, {})
}

export function bendProtectionsToObjects (items) {
  return items ? items.map(item => {
    let colors = getDoubleColorObject(item.bendProtectionColor)
    let obj = Object.assign({}, item, colors)
    return obj
  }) : []
}